import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    img: {
      width: '45%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    imgillustration: {
      width: '25%',
      [theme.breakpoints.down('sm')]: {
        width: '45%',
      },
    },
    bannerTitleContainer: {
      margin: 'auto',
      marginTop: -83,
      [theme.breakpoints.down(1300)]: {
        marginTop: -90,
      },
    },
    bannerTitle: {
      fontStyle: 'normal',
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
      color: 'white',
      fontSize: 20,
      textAlign: 'center',
      [theme.breakpoints.down(1300)]: {
        fontSize: 14,
      },
    },
    paragraphe: {
      fontSize: '15px',
      color: 'black',
      fontFamily: 'ITC Avant Garde Gothic Std Medium',
      marginTop: '10px',
      textAlign: 'justify',
      fontWeight: 'lighter',
      '@media only screen and (max-width: 600px)': {
        textAlign: 'left !important',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'left !important',
      },
    },
    cardBgGrey: {
      padding: 40,
      background: '#e8eef4',
      fontStyle: 'italic',
      '@media only screen and (max-width: 600px)': {
        padding: 20,
      },
      '@media only screen and (max-width: 361px)': {
        padding: 15,
      },
    },
    content: {
      width: '80%',
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        width: '95%',
      },
    },
  }),
);

export default useStyles;
